/* __next_internal_client_entry_do_not_use__ FloatBar auto */import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { NewBaseButton } from "@/components/common/NewBaseButton";
import classNames from "classnames";
import { useEffect, useState } from "react";
import "./index.css";
import { notLoginHandle } from "@/helpers/blog";
import { useTranslations } from "next-intl";
export const FloatBar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const t = useTranslations();
  const handleScroll = e => {
    const scrollHeight = e.target.scrollTop;
    const fullPage = document.querySelector("#fullPage");
    const clientHeight = (fullPage === null || fullPage === void 0 ? void 0 : fullPage.clientHeight) || 0;
    if (clientHeight - scrollHeight < 1400) {
      setIsScrolled(false);
    } else if (scrollHeight > 260) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };
  useEffect(() => {
    const page = document.getElementById("page");
    page === null || page === void 0 ? void 0 : page.addEventListener("scroll", handleScroll);
    return () => {
      page === null || page === void 0 ? void 0 : page.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return /*#__PURE__*/_jsx("div", {
    className: classNames({
      ["float-bar"]: true,
      ["scrolled"]: isScrolled
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: "float-bar-center",
      children: [/*#__PURE__*/_jsx("span", {
        className: "float-bar-text",
        children: t("Seo_Float_Banner_Text")
      }), /*#__PURE__*/_jsx(NewBaseButton, {
        preset: "primary",
        size: "large",
        onClick: notLoginHandle,
        children: t("Seo_Float_Banner_Button")
      })]
    })
  });
};